//eslint-disable-next-line
import { mount, unmount } from "globalNavigationReact/index";
import React, { useEffect } from "react";
import { getPageLocale, convertLocaleFormat } from "@monorepo/utils/locales";

// Shared flag to track if mount has already been called
let isMounted = false;

export const Footer = () => {
    useEffect(() => {
        if (isMounted) {
            return;
        }
        mount({
            headerElemID: "privacy-footer-container",
            footerElemID: "privacy-footer-container",
            showHeader: false,
            showFooter: true,
            footerConfig: {
                showLegalFooter: true,
                showPageFooter: false,
            },
            mountLocale: convertLocaleFormat(getPageLocale(), "xx_XX"),
            mountBrand: "account",
            injectAEMfont: false,
        });
        isMounted = true;
        return () => {
            unmount();
        };
    }, []);

    return <div id="privacy-footer-container"></div>;
};
